// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"63abac32","121":"cdd5e4bc","531":"9dfb3382","584":"cdd5e4bc","801":"256254a1"}[chunkId] + ".chunk.css";
};